module.exports = __webpack_public_path__ + "img/04.b20d57eb.jpg";